import { Modal, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { BarcodeScannerModalGlobalStyle } from './BarcodeScannerModal.styles';
import { BarcodeScannerModalProps } from './BarcodeScannerModal.types';
import { KccButton } from 'lib/components/KccButton/KccButton';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';
import { BARCODE_SCANNER_FILE_READER_ID, BARCODE_SCANNER_READER_ID } from 'app/modules/service/utils/constants';

export const BarcodeScannerModal = ({
  open,
  onClose,
  afterOpenChange,
  permissionDenied,
  onGalleryFileChange,
}: BarcodeScannerModalProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <BarcodeScannerModalGlobalStyle />
      <Modal
        title={t('service.identifyDevice.barcodeScanner.modalTitle')}
        open={open}
        onCancel={onClose}
        footer={null}
        className="barcode-scanner__modal"
        width="100vw"
        destroyOnClose
        afterOpenChange={afterOpenChange}
      >
        <div className="barcode-scanner__camera-container">
          <div id={BARCODE_SCANNER_READER_ID} />
          {permissionDenied && (
            <div className="barcode-scanner__permission-denied">
              {t('service.identifyDevice.barcodeScanner.cameraPermissionDenied')}
            </div>
          )}
          <Upload
            accept="image/*"
            showUploadList={false}
            beforeUpload={(file): boolean => {
              onGalleryFileChange(file);
              return false;
            }}
          >
            <KccButton className="barcode-scanner__gallery-btn" type="link">
              <SvgIcon name="add" className="barcode-scanner__gallery-btn-icon" />
            </KccButton>
          </Upload>
        </div>
        <div id={BARCODE_SCANNER_FILE_READER_ID} style={{ display: 'none' }} />
        <div className="barcode-scanner__modal-text">
          <p className="barcode-scanner__modal-title">{t('service.identifyDevice.barcodeScanner.title')}</p>
          <p className="barcode-scanner__modal-description">{t('service.identifyDevice.barcodeScanner.description')}</p>
        </div>
      </Modal>
    </>
  );
};
